// extracted by mini-css-extract-plugin
export default {"sidebar":"dQy_V7BGtrZ3ffz2Giww","collapsed":"sSTmldqsuSkdVxf6MOPh"};